"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountShape = exports.getTxToBroadcast = exports.getAddress = exports.mapTxToOps = exports.processTxs = exports.getUnit = void 0;
const logs_1 = require("@ledgerhq/logs");
const currencies_1 = require("../../../../currencies");
const bignumber_js_1 = require("bignumber.js");
const types_1 = require("./types");
const api_1 = require("./api");
const account_1 = require("../../../../account");
const operation_1 = require("../../../../operation");
const flatMap_1 = __importDefault(require("lodash/flatMap"));
const getUnit = () => (0, currencies_1.getCryptoCurrencyById)("filecoin").units[0];
exports.getUnit = getUnit;
const processTxs = (txs) => {
    const txsById = txs.reduce((result, currentTx) => {
        const { hash, type } = currentTx;
        const txById = result[hash] || {};
        if (type == "Send" || type == "Fee")
            txById[type] = currentTx;
        result[hash] = txById;
        return result;
    }, {});
    const processedTxs = [];
    for (const txId in txsById) {
        const { Fee: feeTx, Send: sendTx } = txsById[txId];
        if (!sendTx) {
            if (feeTx) {
                (0, logs_1.log)("warn", `feeTx [${feeTx.hash}] found without a sendTx linked to it.`);
            }
            continue;
        }
        if (feeTx) {
            sendTx.fee = feeTx.amount;
        }
        processedTxs.push(sendTx);
    }
    return processedTxs;
};
exports.processTxs = processTxs;
const mapTxToOps = (accountId, { address }) => (tx) => {
    const { to, from, hash, timestamp, amount, fee, status } = tx;
    const ops = [];
    const date = new Date(timestamp * 1000);
    const value = (0, currencies_1.parseCurrencyUnit)((0, exports.getUnit)(), amount.toString());
    const feeToUse = (0, currencies_1.parseCurrencyUnit)((0, exports.getUnit)(), (fee || 0).toString());
    const isSending = address === from;
    const isReceiving = address === to;
    const hasFailed = status !== types_1.TxStatus.Ok;
    if (isSending) {
        ops.push({
            id: (0, operation_1.encodeOperationId)(accountId, hash, "OUT"),
            hash,
            type: "OUT",
            value: value.plus(feeToUse),
            fee: feeToUse,
            blockHeight: tx.height,
            blockHash: null,
            accountId,
            senders: [from],
            recipients: [to],
            date,
            extra: {},
            hasFailed,
        });
    }
    if (isReceiving) {
        ops.push({
            id: (0, operation_1.encodeOperationId)(accountId, hash, "IN"),
            hash,
            type: "IN",
            value,
            fee: feeToUse,
            blockHeight: tx.height,
            blockHash: null,
            accountId,
            senders: [from],
            recipients: [to],
            date,
            extra: {},
            hasFailed,
        });
    }
    return ops;
};
exports.mapTxToOps = mapTxToOps;
const getAddress = (a) => a.freshAddresses.length > 0
    ? a.freshAddresses[0]
    : { address: a.freshAddress, derivationPath: a.freshAddressPath };
exports.getAddress = getAddress;
const getTxToBroadcast = (operation, signature, rawData) => {
    const { senders, recipients, value, fee } = operation;
    const { gasLimit, gasFeeCap, gasPremium, method, version, nonce, signatureType } = rawData;
    return {
        message: {
            version,
            method,
            nonce,
            params: "",
            to: recipients[0],
            from: senders[0],
            gaslimit: gasLimit.toNumber(),
            gaspremium: gasPremium.toString(),
            gasfeecap: gasFeeCap.toString(),
            value: value.minus(fee).toFixed(),
        },
        signature: {
            type: signatureType,
            data: signature,
        },
    };
};
exports.getTxToBroadcast = getTxToBroadcast;
const getAccountShape = (info) => __awaiter(void 0, void 0, void 0, function* () {
    const { address, currency, derivationMode } = info;
    const accountId = (0, account_1.encodeAccountId)({
        type: "js",
        version: "2",
        currencyId: currency.id,
        xpubOrAddress: address,
        derivationMode,
    });
    const blockHeight = yield (0, api_1.fetchBlockHeight)();
    const balance = yield (0, api_1.fetchBalances)(address);
    const rawTxs = yield (0, api_1.fetchTxs)(address);
    const result = {
        id: accountId,
        balance: new bignumber_js_1.BigNumber(balance.total_balance),
        spendableBalance: new bignumber_js_1.BigNumber(balance.spendable_balance),
        operations: (0, flatMap_1.default)((0, exports.processTxs)(rawTxs), (0, exports.mapTxToOps)(accountId, info)),
        blockHeight: blockHeight.current_block_identifier.index,
    };
    return result;
});
exports.getAccountShape = getAccountShape;
//# sourceMappingURL=utils.js.map